<template>
  <div :class="$style.container">
    <h2 class="SubPage__subHeading">
      {{ config.title }}
    </h2>
    <div :class="$style.tabs">
      <div :class="$style.scrollPane">
        <a
          v-for="(tab, index) in config.tabs.length"
          :key="`${index}-aKey`"
          :class="[
            $style.tab,
            activeTab === tab && $style.active,
            config.tabs[index].disabled && $style.disabled,
          ]"
          @click="(e) => updateTabs(e, tab)"
        >
          {{ config.tabs[index].title }}
        </a>
      </div>
    </div>
    <div
      v-for="(tab, index) in config.tabs.length"
      :key="`${index}-bKey`"
      :class="[$style.content, activeTab === tab && $style.activeContent]"
    >
      <template v-if="activeTab === tab">
        <NewsletterSubscribe v-if="tab === 1" :config="config.tabs[index].formConfig" />
        <NewsletterUnsubscribe v-if="tab === 2" :config="config.tabs[index].formConfig" />
      </template>
    </div>
  </div>
</template>

<script setup>
import { checkIsMobile } from '../../utils/media';
import NewsletterSubscribe from './NewsletterSubscribe.vue';
import NewsletterUnsubscribe from './NewsletterUnsubscribe.vue';
import { onMounted, onUnmounted, ref, useCssModule } from 'vue';

const $style = useCssModule();

const props = defineProps({
  config: {
    type: Object,
    default: () => {},
  },
});

const isMobile = ref(false);
const activeTab = ref(null);
const mobileHidden = ref(null);
const activeTabPreselected = ref(false);

const checkScreenSize = () => (isMobile.value = checkIsMobile());

const initTabs = () => {
  for (const [index, tab] of props.config.tabs.entries()) {
    if (tab.active && !tab.disabled) {
      activeTab.value = index + 1;
      activeTabPreselected.value = true;
    }
  }
  if (!activeTabPreselected.value) {
    activeTab.value = 1;
  }
};

const updateTabs = (e, tab) => {
  const elm = e.currentTarget;
  if (!elm.classList.contains($style.disabled)) {
    if (isMobile.value && activeTab.value === tab && activeTab.value !== mobileHidden.value) {
      mobileHidden.value = tab;
    } else if (
      isMobile.value &&
      activeTab.value === tab &&
      activeTab.value === mobileHidden.value
    ) {
      mobileHidden.value = null;
    } else if (isMobile.value && activeTab.value !== tab) {
      mobileHidden.value = null;
      activeTab.value = tab;
    } else {
      activeTab.value = tab;
    }
  }
};

onMounted(() => {
  window.addEventListener('resize', checkScreenSize);
  checkScreenSize();
  initTabs();
});

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize);
});
</script>

<style module lang="scss">
@forward '../ContentTabs/ContentTabs.scss';
</style>
